import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderBookmarks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolderBookmarks"><Path fillRule="evenodd" clipRule="evenodd" d="M2 3H10.4014L12.4014 6H22V20H9.5V11.5H2V3Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M1 13H8V21.5134L4.5 19.6043L1 21.5134V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderBookmarks;
